import '../../app.es6';
import angular from 'angular';
import moment from '../../../node_modules/moment/moment.js';

class LessonDetailController {
  /* @ngInject */
  constructor (
    $scope, $routeParams, $q, $sessionStorage, $window, $resource, $location,
    SharedState, sssSharedState, SwingTypeConstants, ImpactPointConstants,
    commonApiFactory, commonFactory, Const, Page
  ) {
    this.Const = Const;
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = '';
    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
    this.commonFactory = commonFactory;
    this.commonFactory.overlayHidden();
    this.commonFactory.deleteErrorFlg();
    this.$location = $location;

    this.sharedState = sssSharedState;
    this.sharedState.graphPromise = $q.defer();
    this.UiSharedState = SharedState;
    this.swingTypes = SwingTypeConstants;
    this.impactPoints = ImpactPointConstants;
    this.$q = $q;
    this.$window = $window;
    this.group_id = $routeParams.group_id;
    this.date_range = $routeParams.range;
    this.sharedState.title = 'Play Report';
    this.datetimeFormatter = d3.time.format('%Y/%m/%d %X');
    this.dateFormatter = d3.time.format('%Y/%m/%d');
    this.monthFormatter = d3.time.format('%Y/%m');
    this.yearFormatter = d3.time.format('%Y');
    // 遷移時はheatmapを必ず非表示にする
    this.$sessionStorage[this.Const.SSAPP_HEATMAP_FLG] = false;
    // セッションストレージに表示するレッスン情報がない場合、生徒トップ画面へ戻す
    if (this.$sessionStorage[this.Const.SSAPP_TARGET_LESSON_INDEX] == null) {
      this.$location.path('/member');
    }
    // 前画面で表示されるレッスン一覧を取得
    this.lessonList = this.$sessionStorage[this.Const.SSAPP_DISP_LESSON_LIST];
    // 現在表示されているレッスン詳細が、取得したレッスン一覧の何番目のものかを判別する
    this.currentIdx = this.$sessionStorage[this.Const.SSAPP_DISP_LESSON_INDEX];
    /*
     4つのレッスンがある月の4番目のレッスン詳細を開いたあと、
     3つ以下のレッスンしかない月に遷移し、
     端末の戻るボタン・ブラウザの戻るボタンでレッスン詳細に戻ると、
     3つ以下のレッスンの4番目を検索してしまうため、
     this.currentIdxに入る値を、戻るボタンを押す前に表示したレッスン一覧の数 - 1とする
    */
    if (this.currentIdx > this.lessonList.length - 1) {
      this.currentIdx = this.lessonList.length - 1;
    }
    this.startedDate = this.lessonList[this.currentIdx].startedDate;
    this.endedDate = this.lessonList[this.currentIdx].endedDate;
    /*
     表示しようとした内容がsession storageに格納されている値と違っていた場合、
     session storageに格納されているものを正とする
     this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_DATE]は、
     レッスン詳細に遷移するときに格納される
     端末の戻るボタン・ブラウザの戻るボタンでレッスン詳細に戻ると、不整合が生じる
    */
    if (this.startedDate !== this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_DATE]) {
      this.lessonList =
      this.$sessionStorage[this.Const.SSAPP_DISP_LESSON_LIST] =
      this.$sessionStorage[this.Const.SSAPP_TARGET_LESSON_LIST];
      this.currentIdx =
      this.$sessionStorage[this.Const.SSAPP_DISP_LESSON_INDEX] =
      this.$sessionStorage[this.Const.SSAPP_TARGET_LESSON_INDEX];
      this.startedDate = this.lessonList[this.currentIdx].startedDate;
      this.endedDate = this.lessonList[this.currentIdx].endedDate;
    }
    // 一番最後のレッスンを選択した場合、'>'を隠すために取得
    this.lessonListLength = this.lessonList.length - 1;
    if (this.currentIdx === this.lessonListLength) {
      this.maxFlg = true;
    } else {
      this.maxFlg = false;
    }
    // APIからのデータ取得が完了したか判定する
    this.renderFin = this.$sessionStorage[this.Const.SSAPP_RENDER_FIN] = false;

    dc.chartRegistry.clear();
    this.query = {};

    this.installDateChangeListener(this.startedDate, this.endedDate);
    this.shot = crossfilter();
    this.tennis_chart = {
      shot: this.shot,
      reportCtrl: this
    };

    this.commonApiFactory = commonApiFactory;
    this.shotData = [];
    this.resource = $resource;

    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }

    Page.setTitle(this.Const.TITLE.lesson);

    LessonDetailController.$inject = [
      '$scope', '$routeParams', '$q', '$sessionStorage',
      '$window', '$resource', '$location', 'SharedState', 'sssSharedState',
      'SwingTypeConstants', 'ImpactPointConstants',
      'commonApiFactory', 'commonFactory', 'Const', 'Page'
    ];
  }

  setTennisChartCtrl (ctrl) {
    this.tennisChartCtrl = ctrl;
  }

  installDateChangeListener (start, end) {
    let query = {};

    if (this.date_range) {
      this.$scope.$on('mobile-angular-ui.state.changed.dateMode', (e, newVal, oldVal) => {
        query.range = (oldVal) ? newVal : this.date_range;
        if (query.range && query.date) this.getReports(query, start, end);
      });
      this.$scope.$on('mobile-angular-ui.state.changed.date', (e, newVal, oldVal) => {
        query.date = newVal;
        if (query.range && query.date) this.getReports(query, start, end);
      });
    } else {
      this.$scope.$on('mobile-angular-ui.state.changed.dateMode', (e, newVal, oldVal) => {
        console.log(newVal, oldVal);
        query.range = newVal;
        if (query.range && query.date) this.getReports(query, start, end);
      });
      this.$scope.$on('mobile-angular-ui.state.changed.date', (e, newVal, oldVal) => {
        query.date = newVal;
        if (query.range && query.date) this.getReports(query, start, end);
      });
    }
  }

  getReports (query, start, end) {
    query.range = 'day';
    let promiseShot = this.queryShotData(query, start, end);
    if (query.range === 'day') {
      promiseShot.then(() => {
        this.dcRender();
      });
    }
  }

  queryShotData (query, start, end) {
    let changed = false;
    let deferred = this.$q.defer();
    if (this.query.range !== query.range) {
      this.query.range = query.range;
      changed = true;
    }
    let date;
    switch (query.range) {
      case 'day':
        date = this.dateFormatter(query.date);
        break;
      case 'week':
        date = this.dateFormatter(moment(query.date).day(0).toDate());
        break;
      case 'month':
        date = this.monthFormatter(query.date);
        break;
      case 'year':
        date = this.yearFormatter(query.date);
        break;
    }
    if (changed || this.query.date !== date) {
      this.query.date = date;
      changed = true;
    }
    if (!changed) {
      console.log('query not changed', this.query);
      return;
    }
    console.log('querying', this.query);
    // GET members/{memberId}/shots用
    let getMembersMemberIdShotsParams = {
      memberId: this.$sessionStorage[this.Const.SSAPP_MEMBER_ID],
      endDateTime: end,
      beginDateTime: start
    };
    // GET members/me/shots用
    let getMembersMeShotsParams = {
      endDateTime: end,
      beginDateTime: start
    };
    let promiseArray = [];
    if (localStorage.getItem(this.Const.LSAPP_ROLE) !== this.Const.LSAPP_ROLE_MEMBER) {
      promiseArray.push(this.sharedState.graphPromise.promise);
      promiseArray.push(this.commonApiFactory.getMembersMemberIdShots(getMembersMemberIdShotsParams));
    } else {
      promiseArray.push(this.sharedState.graphPromise.promise);
      promiseArray.push(this.commonApiFactory.getMembersMeShots(getMembersMeShotsParams));
    }
    Promise.all(promiseArray).then((arr) => {
      let chart = arr[0];
      let shotData = arr[1]; // APIから取得したデータ
      let dataArray = [];
      let data;
      let beginDate;
      let endDate;
      this.shotData = shotData;
      for (let i = 0; i < this.shotData.length; i++) {
        dataArray.push(this.shotData[i].summaryData);
      }
      data = dataArray;
      if (data.length > 0) {
        beginDate = new Date(start);
        endDate = new Date(end);
      } else {
        beginDate = new Date(start);
        endDate = new Date(end);
        beginDate = new Date(beginDate.setHours(beginDate.getHours() - 23));
        endDate = new Date(endDate.setHours(endDate.getHours() - 23));
      }
      this.formatShotData(data);
      this.setShotData(data);
      deferred.resolve();
      this.tennisChartCtrl.userSeriesChart.x(d3.time.scale().domain([beginDate, endDate]));

      // metricsChartY軸に設定する最小値/最大値
      let yMax = -12;
      let yMin = 12;
      let rightYMax = 0;
      let rightYMin = 220;
      if (this.shotData.length > 0) {
        // this.shotDataがある場合の初期値
        for (let shot of this.shotData) {
          let rightYTmp = 0;
          // spin
          yMax = shot.impact.spin >= yMax ? shot.impact.spin : yMax;
          yMin = shot.impact.spin <= yMin ? shot.impact.spin : yMin;
          // impact.speedとswing.speed
          rightYTmp = shot.swing.speed >= shot.impact.speed ? shot.swing.speed : shot.impact.speed;
          rightYMax = rightYTmp >= rightYMax ? rightYTmp : rightYMax;
          rightYTmp = 0;
          rightYTmp = shot.swing.speed <= shot.impact.speed ? shot.swing.speed : shot.impact.speed;
          rightYMin = rightYTmp <= rightYMin ? rightYTmp : rightYMin;
        }
      } else {
        // this.shotDataがなかった場合の初期値
        yMax = 13;
        yMin = -12;
        rightYMax = 220;
        rightYMin = 0;
      }
      // rightYMaxの一の位を切り上げる
      rightYMax = rightYMax / 10;
      rightYMax = Math.ceil(rightYMax) * 10;
      // rightMinの小数点以下を切り捨てる
      rightYMin = Math.floor(rightYMin);
      // metricsChart左側Y軸に設定する最大値・最小値の設定
      yMax = ((yMax + 0.5) > 10) ? 13 : yMax;
      yMin = ((yMin - 0.5) < -10) ? -12 : yMin;
      // metricsChart右側Y軸に設定する最大値・最小値の設定
      rightYMax = ((rightYMax + 10) > 200) ? 220 : rightYMax;
      rightYMin = ((rightYMin - 10) < 0) ? 0 : rightYMin;
      // yMax、yMinを枠線に収まるように調整
      let num = yMax - yMin;
      if (this.shotData.length > 0) {
        if (num === 0) {
          yMax = 13;
          yMin = -12;
        } else if (yMax - yMin <= 4) {
          yMax = yMax + 0.5;
          yMin = yMin - 0.5;
        } else if (yMax - yMin > 20) {
          yMax = yMax + 0.5;
          yMin = yMin - 0.5;
        } else {
          yMax = yMax + 3;
          yMin = yMin - 2;
        }
      }
      // rightYMax、rightYMinを枠線に収まるように調整
      let rightNum = rightYMax - rightYMin;
      if (rightNum >= 20) {
        if (rightNum % 20 === 0) {
          rightYMax = rightYMax + 20;
          rightYMin = rightYMin - 20;
        } else {
          rightYMax = rightYMax + 15;
          rightYMin = rightYMin - 15;
        }
      } else {
        rightYMax = rightYMax + (rightYMax % 20) + 3;
        rightYMin = rightYMin - (rightYMin % 20);
      }
      this.tennisChartCtrl.metricsChart.y(d3.scale.linear().domain([yMin, yMax]));
      this.tennisChartCtrl.metricsChart.rightY(d3.scale.linear().domain([rightYMin, rightYMax]));

      // brushOn:true の状態でデータが揃う前(X軸の範囲が確定する前)にredrawが起きると、
      // グラフ中の要素のCSSにtranslate(NaN,0)が 設定されてしまうので、データが揃ってから
      // brushOnする
      chart.brushOn(true);
    })
    .catch(() => {
      this.commonFactory.overlayHidden();
    });
    return deferred.promise;
  }

  dcRender () {
    let beginDate = new Date(this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_DATE]);
    let endDate = new Date(this.$sessionStorage[this.Const.SSAPP_LESSON_END_DATE]);
    dc.filterAll();
    this.tennisChartCtrl.userSeriesChart.filter([beginDate, endDate]);
    dc.renderAll();
    dc.redrawAll();
    // シークバーの高さ調整
    let extentEle = document.getElementsByClassName('extent');
    extentEle[0].setAttribute('height', '24');
    // スライダーの領域調整
    let resizeEle = document.getElementsByClassName('resize');
    let resizeE = resizeEle[0].getElementsByTagName('rect');
    let resizeW = resizeEle[1].getElementsByTagName('rect');
    resizeE[0].setAttribute('width', '50');
    resizeW[0].setAttribute('width', '50');
    resizeE[0].setAttribute('height', '40');
    resizeW[0].setAttribute('height', '40');
    this.renderFin = this.$sessionStorage[this.Const.SSAPP_RENDER_FIN] = true;
    this.commonFactory.overlayHidden();
  }

  formatShotData (data, hasDate) {
    if (!data.length) return;
    data.forEach((d, i) => {
      d.index = data.length - i; // TODO
      d.impact.spin =
        (d.impact.spin >= 2850) ? 10
        : (d.impact.spin >= 2550) ? 9
        : (d.impact.spin >= 2250) ? 8
        : (d.impact.spin >= 1950) ? 7
        : (d.impact.spin >= 1650) ? 6
        : (d.impact.spin >= 1350) ? 5
        : (d.impact.spin >= 1050) ? 4
        : (d.impact.spin >= 750) ? 3
        : (d.impact.spin >= 450) ? 2
        : (d.impact.spin >= 150) ? 1
        : (d.impact.spin >= -150) ? 0
        : (d.impact.spin >= -450) ? -1
        : (d.impact.spin >= -750) ? -2
        : (d.impact.spin >= -1050) ? -3
        : (d.impact.spin >= -1350) ? -4
        : (d.impact.spin >= -1650) ? -5
        : (d.impact.spin >= -1950) ? -6
        : (d.impact.spin >= -2250) ? -7
        : (d.impact.spin >= -2550) ? -8
        : (d.impact.spin >= -2850) ? -9
        : -10;
      if (!hasDate) { d.date = new Date(d.impact.timestamp * 1000); }
      d.swing_type = this.swingTypes.getLabel(d.swing.type);
      d.minute = d3.time.minute(d.date);
      d.hour = d3.time.hour(d.date);
      d.day = d3.time.day(d.date);
      d.second = d3.time.second(d.date);
    });
  }

  setShotData (data) {
    data.sort(function (a, b) {
      if (a.date > b.date) return 1;
      if (a.date < b.date) return -1;
      return 0;
    });
    this.shotData = data;
    this.shot.remove();
    this.shot.add(data);
  }

  toNextLesson () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }

    this.renderFin = this.$sessionStorage[this.Const.SSAPP_RENDER_FIN] = false;
    this.currentIdx = this.currentIdx + 1;
    this.$sessionStorage[this.Const.SSAPP_DISP_LESSON_INDEX] =
    this.$sessionStorage[this.Const.SSAPP_TARGET_LESSON_INDEX] = this.currentIdx;
    let nextLesson = this.lessonList[this.currentIdx];
    let nextStartedDate = nextLesson.startedDate;
    let nextEndedDate = nextLesson.endedDate;
    if (this.$sessionStorage[this.Const.SSAPP_DISP_LESSON_INDEX] === this.lessonListLength) {
      this.maxFlg = true;
    } else {
      this.maxFlg = false;
    }
    this.$sessionStorage[this.Const.SSAPP_LESSON_NAME] = nextLesson.courseName;
    this.$sessionStorage[this.Const.SSAPP_LESSON_DATE] = nextLesson.date;
    this.$sessionStorage[this.Const.SSAPP_LESSON_DAY] = nextLesson.day;
    this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_DATE] = nextLesson.startedDate;
    this.$sessionStorage[this.Const.SSAPP_LESSON_END_DATE] = nextLesson.endedDate;
    this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_TIME] = nextLesson.beginTime;
    this.$sessionStorage[this.Const.SSAPP_LESSON_END_TIME] = nextLesson.endTime;
    this.query.date = new Date(this.query.date);
    this.resetChartStyle();
    this.getReports(this.query, nextStartedDate, nextEndedDate);
  }

  toBeforeLesson () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }

    this.renderFin = this.$sessionStorage[this.Const.SSAPP_RENDER_FIN] = false;
    this.currentIdx = this.currentIdx - 1;
    this.$sessionStorage[this.Const.SSAPP_DISP_LESSON_INDEX] =
    this.$sessionStorage[this.Const.SSAPP_TARGET_LESSON_INDEX] = this.currentIdx;
    let beforeLesson = this.lessonList[this.currentIdx];
    let beforeStartedDate = beforeLesson.startedDate;
    let beforeEndedDate = beforeLesson.endedDate;
    if (this.currentIdx === this.lessonListLength) {
      this.maxFlg = true;
    } else {
      this.maxFlg = false;
    }
    this.$sessionStorage[this.Const.SSAPP_LESSON_NAME] = beforeLesson.courseName;
    this.$sessionStorage[this.Const.SSAPP_LESSON_DATE] = beforeLesson.date;
    this.$sessionStorage[this.Const.SSAPP_LESSON_DAY] = beforeLesson.day;
    this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_DATE] = beforeLesson.startedDate;
    this.$sessionStorage[this.Const.SSAPP_LESSON_END_DATE] = beforeLesson.endedDate;
    this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_TIME] = beforeLesson.beginTime;
    this.$sessionStorage[this.Const.SSAPP_LESSON_END_TIME] = beforeLesson.endTime;
    this.query.date = new Date(this.query.date);
    this.resetChartStyle();
    this.getReports(this.query, beforeStartedDate, beforeEndedDate);
  }

  resetChartStyle () {
    dc.filterAll();
    this.$sessionStorage[this.Const.SSAPP_HEATMAP_FLG] = false;
    this.$sessionStorage[this.Const.SSAPP_SHOT_KIND] = this.Const.SHOT_TYPE.all;
    this.tennisChartCtrl.userSeriesChart.selectAll('.dc-chart rect.bar').style('fill', (d) => {
      return this.Const.SHOT_COLOR.all;
    });
    this.tennisChartCtrl.userSeriesChart.select('.dc-chart .brush rect.extent').style('fill', (d) => {
      return this.Const.SHOT_COLOR.all;
    });
    this.tennisChartCtrl.userSeriesChart.selectAll('.dc-chart rect.bar.deselected').style('fill', (d) => {
      return this.Const.SHOT_COLOR.deselected;
    });
    this.tennisChartCtrl.userSeriesChart.colorAccessor((d) => {
      if (d.value) {
        this.tennisChartCtrl.userSeriesChart.selectAll('.dc-chart rect.bar').style('fill', (d) => {
          return this.Const.SHOT_COLOR.all;
        });
        this.tennisChartCtrl.userSeriesChart.select('.dc-chart .brush rect.extent').style('fill', (d) => {
          return this.Const.SHOT_COLOR.all;
        });
        this.tennisChartCtrl.userSeriesChart.selectAll('.dc-chart rect.bar.deselected').style('fill', (d) => {
          return this.Const.SHOT_COLOR.deselected;
        });
      }
    });
  }
}

angular.module('myApp').controller('LessonDetailController', LessonDetailController);



// WEBPACK FOOTER //
// ./app/components/lesson-detail/lesson-detail-controller.es6